import { useCallback } from 'react';

import useInterval from '@swf/sports/hooks/useInterval';

import type { FetchBetsData } from './useFetchMyBets';

export type MyBetsPollingData = Pick<
  FetchBetsData,
  'bets' | 'fetchBets' | 'showLoader' | 'pollingInterval'
> & {
  isSettled: boolean;
};

export const useMyBetsPolling = ({
  bets,
  fetchBets,
  showLoader,
  isSettled,
  pollingInterval
}: MyBetsPollingData) => {
  const initBetsPolling = useCallback(() => {
    if (!showLoader && bets.length && !isSettled) {
      fetchBets({ showLoader, fromRecord: 1, toRecord: bets.length });
    }
  }, [showLoader, bets, fetchBets, isSettled]);

  useInterval(initBetsPolling, pollingInterval, pollingInterval);
};
